import { render, staticRenderFns } from "./sp-feature-highlights.vue?vue&type=template&id=81656708&scoped=true"
import script from "./sp-feature-highlights.vue?vue&type=script&lang=js"
export * from "./sp-feature-highlights.vue?vue&type=script&lang=js"
import style0 from "./sp-feature-highlights.vue?vue&type=style&index=0&id=81656708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81656708",
  null
  
)

export default component.exports